
/* injects from baggage-loader */

'use strict';

import ProjectInvestmentWizardStep3Controller from './projectinvestmentwizard.step3.controller';
import ProjectInvestmentWizardStep3Template from './projectinvestmentwizard.step3.html';

export default class ProjectInvestmentWizardStep3Component {
		constructor() {
				this.templateUrl = ProjectInvestmentWizardStep3Template;
				this.controller = ProjectInvestmentWizardStep3Controller;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/step3/projectinvestmentwizard.step3.component.js